module.exports = __webpack_public_path__ + "static/media/12A.6da0d672.jpg";